import React from 'react';

import withLayout from '../../../hoc/with-layout';
import UserController from './user.controller';

const UserScreen: React.FC = () => {
  return <UserController />;
};
export default withLayout(UserScreen);
